<template>
  <v-app-bar app
    color="white" 
    height="85">
    <v-container class="pa-0" fluid>
      <v-row class="align-start gradient 
        mx-n4"
        :class="[$vuetify.breakpoint.mdAndDown ? 'px-2' : 'px-12']"
        no-gutters>
          <v-col class="slogan text-right hidden-sm-and-down"><i>smart business learning</i></v-col>
          <!--languages-->
          <v-col>
            <v-btn text small color="white"
              @click="changeLocale('en-US')">
              EN
            </v-btn>
            <v-btn text small color="white"
              @click="changeLocale('ro-RO')">
              RO
            </v-btn>
            <v-btn text small color="white"
              @click="changeLocale('ru-RU')">
              RU
            </v-btn>
          </v-col>
          <!------------------------------>
      </v-row>
      <!-- middle && large -->
    <div class="hidden-xs-only">
        <v-row class="align-end mx-12" justify="space-between">
            <v-col class="mt-n6">
            <!--logo-->
            <router-link to="/">
                <v-img 
                :src="require('@/assets/logo.png')"
                max-height="49"
                max-width="43">
                </v-img>
                <div class="ml-8 mt-n8 logo-text text-left">Dolfy</div>
            </router-link>
            </v-col>
        
            <v-col v-for="item in menuButtons"
            class="text-center py-2 font-weight-medium"
            :key="item.title">
            
            <router-link
                :class="isActive(item) ? 'secondary--text' : 'primary--text'"
                :to="item.url">
                {{ item.title | localize }}
            </router-link>
            </v-col> 
        </v-row>
    </div>
      
      <!-- small  -->
        <div class="hidden-sm-and-up">
          <v-row justify="center" class="align-center">
            <v-col class="mt-n6">
              <!--logo-->
              <router-link to="/">
                <v-img 
                  :src="require('@/assets/logo.png')"
                  max-height="49"
                  max-width="43">
                </v-img>
                <div class="ml-8 mt-n8 logo-text text-left">Dolfy</div>
              </router-link>
            </v-col>
            <v-col class="mr-auto">
              <v-menu offset-y
                transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-app-bar-nav-icon v-on="on">
                  </v-app-bar-nav-icon>     
                </template>
                <v-list>
                  <v-list-item-group
                    v-model="selectedItem"
                  >
                  <v-list-item link
                    v-for="(item, index) in menuButtons"
                    :key="index">
                    <v-list-item-title class="text-justify">
                      <router-link :to="item.url">
                        {{ `${item.title}` | localize }}
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>
    </v-container>
  </v-app-bar>
</template>

<script>

export default  {
    data() {
      return {}
    },
    computed: {
      locale() {
        return this.$store.getters.locale;
      },
      loggedIn () {
        return this.$store.getters.loggedIn;
      },
      user () {
        return this.$store.getters.user;
      },
      menuButtons () {
        if (this.loggedIn) {
          if (this.user.role == 'ADMIN') {
            return [
              { title: 'Promo & Users', url: '/admin/promo/profile'},
              { title: 'Market', url: '/admin/market/segments'},
              { title: 'Teams & Descisions', url: '/admin/teams/teams'},
              { title: 'Summary', url: '/admin/summary/franchise'}
              ]
            }
          else if (this.user.role == 'PROFESSOR') {
            return [
              { title: 'Profile', url: '/professor/profile' },
              { title: 'Games', url: '/professor/games' },
            ]
          }
          else {
            return [
              { title: 'Profile', url: '/team/profile'},
              { title: 'Market', url: '/team/market/marketOverview'},
              { title: 'Decisions', url: '/team/decisions/products'},
              { title: 'Reports', url: '/team/reports/sales'},
            ]
          }
        }
        return []
      },
      selectedItem: {
        get() {
          const item = this.menuButtons.find(it => it.url === this.$route.path)
          return this.menuButtons.indexOf(item) || 0
        },
        set(val) {
          return val
        }
      },
    },
    watch: {
      locale() {
        localStorage.setItem('locale', JSON.stringify(this.locale));
      }
    },
    methods: {
      isActive(item) {
        const url = item.url
        const arr = this.$route.path.split('/')
        let path = `/${arr[1]}/`
        
        if (!this.loggedIn) {
          return Boolean( url == this.$route.path)
        }
        else {
          path = `/${arr[2]}`
          return Boolean(url.includes(path))
        }
      },
      async changeLocale(locale) {
        await this.$store.dispatch('setLocale', locale);
      },
      async onLogout () {
        try {
          await this.$store.dispatch('logoutUser')
          this.$router.replace('/')
        }
        catch(error) {
          this.$store.dispatch('setError', error.message)
        }
      }
    }
  }
</script>
<style scoped>
  
  .logo-text {
    font-family: 'Rajdhani';
    font-weight: bold;
    font-size: 1.8em;
    color: #607D8B;/*blue*/
  }
  a {
     text-decoration-line: none;
  }
  .slogan{
    font-family: 'Rajdhani';
    letter-spacing: 2px;
    margin-top: 3.5px;
    color: #fff;  
  }
  .gradient {
    text-align: right;
    background: linear-gradient(90deg, #ffffff 22%, #607D8B 35%);
  }
</style>
